<template>
  <nav id="header-view">
    <!-- Left elements -->
    <div class="left-elem centered">
      <component
        v-if="this.$route.meta.navigation && this.$route.meta.navigation.left"
        :is="this.$route.meta.navigation.left.component"
        v-bind="this.$route.meta.navigation.left.props">
      </component>
    </div>

    <!-- Center elements -->
    <div class="text-center">
      <h1 class="catalog-title visible-default" v-if="this.$route.meta.navigation && this.$route.meta.navigation.title()">
        {{ this.$route.meta.navigation.title() }}
      </h1>
      <img class="resort-logo invisible-default" v-if="resort && resort.logo" :src="resort.logo"/>
      <h1 class="resort-name invisible-default" v-else-if="resort && resort.name">{{ resort.name }}</h1>
    </div>

    <div class="right-elem centered justify-end">
      <component
        v-if="this.$route.meta.navigation && this.$route.meta.navigation.right"
        :is="this.$route.meta.navigation.right.component"
        v-bind="this.$route.meta.navigation.right.props">
      </component>
    </div>

  </nav>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: "ria-navbar",
  computed: {
    ...mapGetters("resort", ["resort"]),
  },
};

</script>

<style scoped>
/* GENERAL */
#header-view {
  @apply fixed top-0 left-0 w-full p-2 z-10 bg-grey-bg flex content-center justify-between items-center;
}

.left-elem, .right-elem {
  @apply flex-1
}

.left-elem {
  @apply text-secondary;
}

.centered {
  @apply flex content-center flex-wrap;
}

.resort-name {
  @apply text-2xl text-white;
}

/* SPECIFIC */
.catalog-title {
  @apply text-secondary text-xl;
}

@screen lg {
  #header-view {
    @apply relative h-20 bg-primary p-5
  }

  .resort-logo {
    max-height: 60px;
    width: auto;
  }
}
</style>
